export const radii = {
  sm: 4,
  md: 8,
  lg: 16,
  xl: 32,
  rounded: 9999,
} as const;

export type RadiusKey = keyof typeof radii;
